export enum EducationLevel {
    GED = 'High-school / GED / Artisanal apprenticeship ',
    DIPLOMA = 'Diploma / Trade school / Military training  ',
    BACHELORS = 'BACHELORS',
    MASTERS = 'MASTERS',
    PHD = 'PHD'
}
